import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ITrackingAction, ITrackingObject } from 'i2g-ng-tracking';
import { IconSizesEnum, IIcon } from '../icon/icon.component';

@Component({
  selector: 'i2g-job-file-list-item',
  templateUrl: './job-file-list-item.component.html',
  styleUrls: ['./job-file-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobFileListItemComponent implements OnInit {
  @Input() fileId: string;
  @Input() fileName: string;
  @Input() fileType: string;
  @Input() showDeleteButton: boolean;
  @Input() trackingAction: ITrackingAction;
  @Input() trackingObject: ITrackingObject;
  @Output() deleteFile = new EventEmitter<string>();
  @Output() clickFile = new EventEmitter<string>();

  imageIcon: IIcon = {
    name: 'image-file',
    size: IconSizesEnum.medium,
  };

  pdfIcon: IIcon = {
    name: 'pdf-file',
    size: IconSizesEnum.medium,
  };

  deleteIcon: IIcon = {
    name: 'trash-white',
    size: IconSizesEnum.medium,
  };

  constructor() {}

  ngOnInit(): void {}
}
